
import {
    Component,
    Prop
} from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import PageRequest from '@/store/entities/page-request';
import {
    LinkToUserInput
} from '@/Areas/AppAreaName/Views/admin/entities/LinkToUserInput'
class linkedUser implements LinkToUserInput {
    tenancyName ? : string;
    usernameOrEmailAddress: string;
    password: string;
}

@Component({})
export default class createUserLinkedModal extends AbpBase {
    //父子组件传值
    @Prop({
        type: Boolean,
        default: false
    }) value: boolean
    //数据
    UserFrom: linkedUser = new linkedUser();
    UserFromRule = {
        usernameOrEmailAddress: [{
            required: true,
            message: 'The usernameOrEmailAddress cannot be empty',
            trigger: 'blur'
        }],
        password: [{
            required: true,
            message: 'The password cannot be empty',
            trigger: 'blur'
        }]
    }
    //计算属性

    //自定义方法
    save() {
        this.$store.dispatch({
            type:'userlinked/createUserLinked',
            data:this.UserFrom
        }).then((result)=>{
            this.$Message.success(this.L('SuccessfullyAdded'));
            this.$emit('save-success');
        }).catch(()=>{
            
        })
        this.$emit('save-success');
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        }
    }
}
